import { cn } from '@/lib/utils';
import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode } from 'react';
import { forwardRef } from 'react';

type CommonProps = {
  className?: string;
  children: ReactNode;
  title?: string;
};

type ModeChipDivProps = CommonProps & HTMLAttributes<HTMLDivElement> & {
  as?: 'div';
};

type ModeChipButtonProps = CommonProps & ButtonHTMLAttributes<HTMLButtonElement> & {
  as?: 'button';
};

export const ModeChip = forwardRef<HTMLDivElement | HTMLButtonElement, ModeChipDivProps | ModeChipButtonProps>(
  function ModeChip(props, ref) {
    const { as, className, children, ...rest } = props as any;
    const classes = cn(
      // layout + shape
      'inline-flex items-center gap-1.5 rounded-full border border-sidebar-border/30 shadow-sm',
      // size
      'h-6 px-2.5 leading-none',
      // color (theme-aware)
      'text-[10px] font-bold uppercase tracking-wider text-muted-foreground/70 bg-sidebar-accent/50 backdrop-blur-md',
      className
    );

    const style: React.CSSProperties = {
      // 新 UI：现代极简风格
      transform: 'translateZ(0)',
    } as const;

    if (as === 'button' || 'onClick' in (props as any) || (props as any).type) {
      const { type = 'button' } = props as any;
      return (
        <button ref={ref as any} type={type} className={classes} style={style} {...(rest as any)}>
          {children}
        </button>
      );
    }

    return (
      <div ref={ref as any} className={classes} style={style} {...(rest as any)}>
        {children}
      </div>
    );
  }
);


